<template>
  <div class="ce-mobileDocResult-asset">
    <div class="flex items-center">
      <div>
        {{ typeLabel }}

        <fa-icon
          v-if="mostRestrictiveAccessLevel && mostRestrictiveAccessLevel.code === 'internal'"
          transform="up-4 shrink-4"
          icon="lock" />
      </div>
    </div>
    <div class="ce-mobileDocResult-meta">
      <div>
        <strong>{{ $t('productSheets.industries.label') }}</strong>: {{ industriesLabel }}
      </div>
    </div>
    <div class="ce-mobileDocResult-actions">
      <div class="ce-documentResult-selectCta">
        <checkbox
          class="ce-checkbox--small"
          :id="`${asset.id}`"
          :value="isInBasket"
          @input="toggleBasket"
          :show-label="false" />
      </div>

      <div class="ce-documentResult-favoriteCta">
        <a
          href=""
          @click.prevent="toggleFavorite">
          <fa-icon :icon="favoriteStateIcon" />
        </a>
      </div>

      <div class="ce-documentResult-downloadCta">
        <a
          href=""
          @click.prevent="startDownload"
          target="_blank">
          <fa-icon
            icon="download" />
        </a>
      </div>
    </div>

    <MsdsDocumentDownloadModal
      v-if="downloadModalVisible"
      @close="cancelDownload"
      :emg="product.prd" />
  </div>
</template>

<script>
import DocumentResultAsset from 'mixins/product-sheets/DocumentResultAsset';
import MsdsDocumentDownloadModal from 'components/MsdsDocumentDownloadModal.vue';

export default {
  mixins: [DocumentResultAsset],
  components: { MsdsDocumentDownloadModal },
  data() {
    return {
      downloadModalVisible: false,
    };
  },
  computed: {
    industriesLabel() {
      if (!this.asset.industries || this.industries.length === this.asset.industries.length) {
        return this.$t('productSheets.industries.forMobile');
      }

      return this.industries.filter((ind) => this.asset.industries.includes(ind.code)).map((ind) => ind.title).join(', ');
    }
  },
  methods: {
    startDownload() {
      this.downloadModalVisible = true;
    },
    cancelDownload() {
      this.downloadModalVisible = false;
    },
  }
};
</script>

<style lang="less">
  @import (reference) '~styles/includes/base';

  .ce-mobileDocResult-asset {
    padding: @space-2 @space-2 @space-2 @space-4;
    border-bottom: 1px solid @color-mono-92;

    @media screen and (min-width: @breakpoint-xs) {
      padding-left: 66px;
    }

    .ce-resultStateIndicators {
      margin-right: @space-1;
    }

    .ce-mobileDocResult-meta {
      .ms(-2);
      display: flex;
      margin-top: @space-2;
      .mxn1;

      > * {
        margin: 0 @space-1;
      }
    }

    .ce-mobileDocResult-actions {
      display: flex;
      margin-top: @space-2;
      .mxn2;

      > * {
        margin: 0 @space-2;
      }
    }
  }
</style>
